module.exports = __webpack_public_path__ + "static/img/video_cover.0601c327.png";